const ENROLLMENT_STATUS: Record<string, string> = {
  active: 'Actief in sequence',
  completed: 'Sequence afgerond',
  stopped_reply: 'Gestopt: reply ontvangen',
  stopped_bounce: 'Gestopt: bounce',
  stopped_suppression: 'Gestopt: suppressielijst',
  stopped_deal: 'Gestopt: open deal',
  paused: 'Gepauzeerd (campagnestop)',
};

const PAUSE_REASON: Record<string, string> = {
  bounce_spike: 'Gepauzeerd: bounce % hoog (7d)',
  daily_limit: 'Gepauzeerd: daglimiet mailbox',
  hourly_limit: 'Gepauzeerd: uurlimiet mailbox',
  no_mailbox: 'Gepauzeerd: geen mailbox',
  no_brevo: 'Gepauzeerd: Brevo-integratie ontbreekt',
  no_brevo_sender: 'Gepauzeerd: geen Brevo-afzender',
  brevo_daily_limit: 'Gepauzeerd: Brevo daglimiet',
  brevo_hourly_limit: 'Gepauzeerd: Brevo uurlimiet',
  mailbox_error: 'Gepauzeerd: mailboxfout',
};

export function labelEnrollmentStatus(status: string): string {
  return ENROLLMENT_STATUS[status] ?? status;
}

export function labelCampaignPauseReason(reason: string | null | undefined): string | null {
  if (!reason) return null;
  return PAUSE_REASON[reason] ?? `Gepauzeerd: ${reason}`;
}
